export default defineNuxtPlugin(async (nuxtApp) => {
  if (process.client) return
  const runtimeConfig = useRuntimeConfig()
  const i18n = nuxtApp.$i18n
  const { locales, defaultLocale } = runtimeConfig.public.i18n
  const { pathname } = useRequestURL(nuxtApp)
  
  const headers = useRequestHeaders([
    'x-forwarded-for',
    'cf-connecting-ip',
    'fastly-client-ip',
    'true-client-ip',
  ])
  
  let ip =
    headers['cf-connecting-ip'] ||
    headers['x-forwarded-for'] ||
    headers['fastly-client-ip'] ||
    headers['true-client-ip'] ||
    ''
  
  if (ip.includes(',')) {
    ip = ip.split(',')[0].trim()
  }
  
  if (process.env.NODE_ENV === 'development') {
    ip = ''
  }

  const detectedCountryState = useState('detectedCountry')
  const countrySelectedState = useState('countrySelected')

  const detectedCountryCookie = useCookie('detectedCountry', {
    path: '/',
    maxAge: 60 * 60 * 24 * 30
  })
  const countrySelectedCookie = useCookie('countrySelected', {
    path: '/',
    maxAge: 60 * 60 * 24 * 30
  })

  const matchCode = locales.find(locale => String(locale.code) === pathname?.split('/')[1])?.code
  if (matchCode) {
    countrySelectedState.value = pathname?.split('/')[1]
  }

  if (pathname === '/' && detectedCountryCookie.value !== undefined) {
    i18n.locale.value = detectedCountryCookie.value
    detectedCountryState.value = detectedCountryCookie.value
    countrySelectedState.value = detectedCountryCookie.value
    navigateTo(`/${detectedCountryCookie.value}`, {
      replace: true,
      redirectCode: 301
    })

    return
  }
  
  if (detectedCountryCookie.value) {
    i18n.locale.value = detectedCountryCookie.value
    detectedCountryState.value = detectedCountryCookie.value
    return
  }

  const setPageLocale = (code = null) => {
    if (code) {
      detectedCountryCookie.value = code
      countrySelectedCookie.value = code

      detectedCountryState.value = code
      countrySelectedState.value = code
      i18n.setLocale(code)
    } else {
      detectedCountryCookie.value = defaultLocale
      detectedCountryState.value = defaultLocale
      i18n.setLocale(defaultLocale)

      if (pathname === '/') {
        countrySelectedCookie.value = null
        countrySelectedState.value = null
      }
    }
  }

  try {
    const response = await $fetch(`${runtimeConfig.IPAPI_API_URL}/${ip}?key=${runtimeConfig.IPAPI_KEY}`)
    const countryCode = String(response?.countryCode).toLowerCase()
    const exactMatch = locales.find(locale => String(locale.code) === countryCode)

    setPageLocale(exactMatch?.code)
  } catch (error) {
    setPageLocale()
    console.error(error)
  }
})
